import React from 'react';
import componentProps from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import SplitInfoCardContent from '../SplitInfoCardContent';
import { splitInfoCardGridItemProps } from '../layout';
import { GridWithMargins, SplitInfoCardGridItem } from '../styles';
import { SplitInfoCardProps } from '../types';

const SplitInfoCard: React.FC<SplitInfoCardProps> = ({
  icon,
  heading,
  body,
  phoneNumber,
  phoneNumberAria,
  openingHours,
  openPhoneInNewTab,
  ...props
}) => (
  <GridWithMargins {...componentProps(props)}>
    <SplitInfoCardGridItem {...splitInfoCardGridItemProps} focusable>
      <SplitInfoCardContent
        icon={icon}
        heading={heading}
        body={body}
        phoneNumber={phoneNumber}
        phoneNumberAria={phoneNumberAria}
        openingHours={openingHours}
        openPhoneInNewTab={openPhoneInNewTab}
      />
    </SplitInfoCardGridItem>
  </GridWithMargins>
);

export default applyComponentTheme(SplitInfoCard, 'SplitInfoCard');
